import React, { useCallback } from 'react';
import {
  authTrigger, isUserLoggedIn, setAuthPathAttribute,
} from '@alumni_v2/utils/helpers';
import { PLACEMENT_BANNER_LINK } from '@alumni_v2/utils/constants';
import ExitIntentPlacementDesktop
  from '@alumni_v2/images/webp/exit-intent-placement.webp';
import ExitIntentPlacementMobile
  from '@alumni_v2/images/webp/exit-intent-placement-mobile.webp';
import {
  Button, cx, View,
} from '@vectord/ui';
import { useMediaQuery } from '@common/hooks';
import { gtmEventHandler } from '@common/utils/gtm';

const PlacementReport = ({ className = '' }) => {
  const { mobile } = useMediaQuery();

  const downloadBrochure = useCallback(() => {
    if (isUserLoggedIn()) {
      window.open(PLACEMENT_BANNER_LINK, '_blank');
    } else {
      setAuthPathAttribute(PLACEMENT_BANNER_LINK);
      authTrigger();
    }
  }, []);

  const viewReportHandle = useCallback(() => {
    gtmEventHandler(
      'cta',
      'download_placement_report',
      'click',
      'alumni_directory',
      {
        element_position: 'exit-intent',
      },
    );
    downloadBrochure();
  }, [downloadBrochure]);

  const getImgUrl = () => (
    mobile
      ? ExitIntentPlacementMobile
      : ExitIntentPlacementDesktop
  );

  return (
    <View className={cx('vd-flex-col vd-justify-center vd-gap-12', className)}>
      <img
        src={getImgUrl()}
        alt="rcb placement"
        height="350"
        className="vd-self-center"
      />
      <Button
        iconRight="arrow-up-right"
        size="m"
        buttonType="solid"
        variants="hero"
        weight="bold"
        className=""
        title="View Report Now"
        upperCase={false}
        onClick={viewReportHandle}
      />
    </View>
  );
};

export default PlacementReport;
